export default __webpack_public_path__ + "static/media/logo-us-dkny.c7334e1b.svg";